import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogComponent } from './catalog/catalog.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { ApiComponent } from './api/api.component';
import { AdminPortalComponent } from './admin/portal/admin-portal.component';
import { AdminTechnologyEditorComponent } from './admin/technology/technology-editor/admin-technology-editor.component';
import { AdminTechnologyComponent } from './admin/technology/admin-technology.component';
import { AdminUsersComponent } from './admin/users/admin-users.component';
import { AdminTerminologyComponent } from './admin/terminology/admin-terminology.component';
import { ViewerComponent } from './viewer/viewer.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { CanDeactivateGuard } from './admin/can-deactivate/can-deactivate.guard';
import { AdminServicesComponent } from './admin/services/admin-services.component';
import { AdminPartnersComponent } from './admin/partners/admin-partners.component';
import { AdminSLAsComponent } from './admin/slas/admin-slas.component';
import { AdminSuitesComponent } from './admin/suites/admin-suites.component';
import { AdminServicesEditorComponent } from './admin/services/services-editor/admin-services-editor.component';
import { AdminPartnersEditorComponent } from './admin/partners/partners-editor/admin-partners-editor.component';
import { AdminSuitesEditorComponent } from './admin/suites/suites-editor/admin-suites-editor.component';
import { AdminProductLinesComponent } from './admin/product-lines/admin-product-lines.component';
import { AdminStatusesComponent } from './admin/statuses/admin-statuses.component';
import { DefinitionsComponent } from './definitions/definitions.component';
import { AdminTerminologyContainerComponent } from './admin/terminology/admin-terminology-container.component';
import { AdminTermChangesComponent } from './admin/terminology/admin-term-changes.component';
import { AdminTerminologyChangeLogComponent } from './admin/terminology/admin-terminology-change-log.component';
import { AdminFullChangeLogComponent } from './admin/full-change-log/admin-full-change-log.component';
import { TechLibraryComponent } from './tech-library/tech-library.component';
import { ChangesComponent } from './changes/changes.component';
import { DownloadsDetailComponent } from './downloads-detail/downloads-detail.component';
import { AdminDownloadsComponent } from './admin/downloads/admin-downloads.component';
import { SourcesComponent } from './sources/sources.component';
import { AdminSourcesComponent } from './admin/sources/admin-sources.component';
import { AdminSourcesEditorComponent } from './admin/sources/sources-editor/admin-sources-editor.component';
import { ReloadComponent } from './reload/reload.component';
import { TechLibraryViewerComponent } from './tech-library-viewer/tech-library-viewer.component';
import { AdminFeedbackComponent } from './admin/feedback/admin-feedback.component';
import { AdminKeysComponent } from './admin/keys/admin-keys.component';

const appRoutes: Routes = [
    {
        path: '', canActivate: [OktaAuthGuard], children: [
            { path: '', redirectTo: 'catalog', pathMatch: 'full' },
            { path: 'api', component: ApiComponent },
            { path: 'definitions', component: DefinitionsComponent },
            { path: 'downloads', component: DownloadsComponent },
            { path: 'catalog', component: CatalogComponent },
            { path: 'sources', component: SourcesComponent },
            { path: 'reload', component: ReloadComponent },
            {
                path: 'admin',
                component: AdminPortalComponent,
                children: [
                    { path: 'suites', component: AdminSuitesComponent },
                    { path: 'suites/editor', component: AdminSuitesEditorComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'technology', component: AdminTechnologyComponent,},
                    { path: 'technology/editor', component: AdminTechnologyEditorComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'services', component: AdminServicesComponent },
                    { path: 'services/editor', component: AdminServicesEditorComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'partners', component: AdminPartnersComponent },
                    { path: 'partners/editor', component: AdminPartnersEditorComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'sources', component: AdminSourcesComponent },
                    { path: 'sources/editor', component: AdminSourcesEditorComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'change-log', component:  AdminFullChangeLogComponent },
                    { path: 'feedback', component:  AdminFeedbackComponent },
                    { path: 'users', component: AdminUsersComponent },
                    { 
                        path: 'terminology', 
                        component: AdminTerminologyContainerComponent,
                        children: [
                            { path: 'list', component: AdminTerminologyComponent },
                            { path: 'requests', component: AdminTermChangesComponent },
                            { path: 'change-log', component: AdminTerminologyChangeLogComponent }
                        ]
                    },
                    { path: 'product-lines', component: AdminProductLinesComponent },
                    { path: 'statuses', component: AdminStatusesComponent },
                    { path: 'slas', component: AdminSLAsComponent },
                    { path: 'downloads', component: AdminDownloadsComponent },
                    { path: 'keys', component: AdminKeysComponent },
                    {
                        path: '**',
                        redirectTo: 'suites'
                    }
                ],
            },
            { path: 'tech-catalog-generate', component: TechLibraryComponent },
            { path: 'downloads-detail', component: DownloadsDetailComponent }
        ]
    },
    { path: 'changes', component: ChangesComponent },
    { path: 'tech-catalog', component: TechLibraryViewerComponent },
    { path: 'viewer', component: ViewerComponent },
    { path: 'login/callback', component: OktaCallbackComponent },
    { path: '**', redirectTo: 'catalog', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
